module.exports = __webpack_public_path__ + "img/via_negociavel.561a8547.png";